export type WebPluginLoadStrategy =
    | "source"
    | "source+gateway-cloud"
    | "gateway"
    | "none";

interface ResolveWebPluginLoadStrategyOptions {
    isDev: boolean;
    mode: string;
}

export function resolveWebPluginLoadStrategy({
    isDev,
    mode,
}: ResolveWebPluginLoadStrategyOptions): WebPluginLoadStrategy {
    if (isDev && mode === "local") {
        return "source+gateway-cloud";
    }

    if (mode === "local" || mode === "cloud") {
        return "gateway";
    }

    if (isDev && mode === "none") {
        return "source";
    }

    return "none";
}
